<template>
    <div>
        <!-- 表格 -->
        <kt-table
            ref="table"
            :loadingData="loading"
            :tableData="tableData"
            :dataFront="columns"
            @sortChange="handSortChange"
            @batchchoice="handleSelectionChange"
            :cellStyle="cellStyle"
            :selectShow="selectShow"
            :row-key="rowKey"
        >
        </kt-table>
        <!-- 分页 -->
        <kt-pag 
            :currentPage="params.page"
            :pageCount="total"
            :limit="params.limit"
            @onChange="handleChange"
            :pageSizeList="pageSizeList"
        >
        </kt-pag>
    </div>
</template>

<script>
import KtTable from './KtTable'
import KtPag from './KtPag'
export default {
    props: {
        columns: Array, //表头显示
        intApi: Function, //请求接口
        loadingData: { //加载显示
            type: Boolean,
            default: false
        },
        params: { //请求接口参数
            type: Object,
            default(){
                return {}
            }
        },
        selectShow: { //是否显示勾选
            type: Boolean,
            default: false
        },
        cellStyle: {
            type: Object,
            default(){
                return { background: '#EFF4FF', color: '#999' }
            }
        },
        pageSizeList: { //页码数值
            type: Array,
            default(){
                return [10, 20, 50, 100]
            }
        },
        dataKey: {
            type: String,
            default: 'rows'
        },
        totalKey: {
            type: String,
            default: 'count'
        },
        rowKey: {
            type: String,
            default: ''
        }
    },
    components: {
        KtTable,
        KtPag
    },
    data() {
        return {
            loading: false,
            tableData: [], //表格数据
            total: 0, //总数
        }
    },
    methods:{
        //获取数据
        async handleList(params){
            try {
                this.loading = true
                let api = this.intApi
                if(typeof api !== 'function') return console.error(new Error('this is intApi not a function'))
                const { status, message, data } = await api(params)
                status === '0' ? null : this.$message({ type: 'error', message, showClose: true })
                if(status === '0'){
                    this.tableData = data[this.dataKey]
                    this.total = data[this.totalKey]
                    this.$emit('handleData', data)
                }
                this.loading = false
            } catch (e) {
                this.loading = false
                this.$message({ message: `异常:${e}`, type: 'error', showClose: true })
            }
        },
        //勾选
        handleSelectionChange(val) {
            this.$emit("batchchoice", val);
        },
        //排序
        handSortChange({order, prop}){
            this.$emit("sortChange", {order, prop});
        },
        handleChange({ page, limit }){
            this.$emit('onChange', { page, limit })
        },
        //重置勾选
        clearSelection(){
            this.$refs.table.clearSelection()
        }
    },
    watch:{
        loadingData: function (val,oldval){
            this.loading = val
        },
        intApi: function () {
            this.tableData = []
            this.total = 0
        }
    }
}
</script>